module.exports = __webpack_public_path__ + "img/ada-hegerberg.cdfa7f8a.png";